import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { startLoading, stopLoading } from "./commonSlice";
import { supabase } from "../config/supabaseClient";
import { generateTrainingPageBatchJobTypes } from "../constant/constants";

export const addData = createAsyncThunk(
  "programes/add",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoading());
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/importTrainingCatalogue`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_BACKEND_API_KEY}`,
          },
        }
      );
      dispatch(stopLoading());
      const jsonRes = await response.json();
      return jsonRes;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const CreateTraining = createAsyncThunk(
  "programes/create",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoading());
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/importTrainingCatalogue`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_BACKEND_API_KEY}`,
          },
        }
      );
      dispatch(stopLoading());
      const jsonRes = await response.json();
      return jsonRes;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const employeeStatistics = createAsyncThunk(
  "statistics/employee",
  async (companyId, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/statistics/${companyId}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_BACKEND_API_KEY}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const allocatePrograms = createAsyncThunk(
  "programs/allocatePrograms",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/generateTraining/${data.companyId}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_BACKEND_API_KEY}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const trainingHistory = createAsyncThunk(
  "trainingHistory",
  async (companyId, { rejectWithValue }) => {
    try {
      const { data, error } = await supabase
        .from("batch_jobs")
        .select("*")
        .eq("company_id", companyId)
        .in("job_type", generateTrainingPageBatchJobTypes)
        .order("created_at", { ascending: false });

      if (error) return rejectWithValue(error.message);

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const trainingProgrammeSlice = createSlice({
  name: "trainingProgramme",
  initialState: {
    programmes: [],
    allocatedPrograms: [],
    statistics: {},
    message: "",
    error: null,
    loading: false,
    history: [],
    historyTableId: null,
    summary: {},
  },
  reducers: {
    addHistoryTableId: (state, action) => {
      state.historyTableId = action.payload;
    },
    addHistoryData: (state, action) => {
      const payload = action.payload;
      if (!payload?.id) {
        state.history = [payload, ...state.history];
        return;
      }
      const idx = state.history.findIndex((h) => h.id === payload.id);
      if (idx >= 0) {
        state.history[idx] = payload;
      } else {
        state.history = [payload, ...state.history];
      }
    },
    deleteHistoryData: (state, action) => {
      state.history = state.history.filter(
        (ele) => ele.id != action.payload.id
      );
    },
    addSummary: (state, action) => {
      state.summary = action.payload;
    },
    addPrograms: (state, action) => {
      state.allocatedPrograms = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addData.fulfilled, (state, action) => {
        state.message = action.payload.message;
        state.loading = false;
      })
      .addCase(addData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(allocatePrograms.pending, (state, action) => {
        state.loading = true;
        // state.allocatedPrograms = [];
        state.error = null;
      })
      .addCase(allocatePrograms.fulfilled, (state, action) => {
        state.loading = false;
        // state.allocatedPrograms = action.payload.data;
      })
      .addCase(allocatePrograms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error;
      })
      .addCase(employeeStatistics.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(employeeStatistics.fulfilled, (state, action) => {
        state.loading = false;
        state.statistics = action.payload.data;
      })
      .addCase(employeeStatistics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error;
      })
      .addCase(trainingHistory.pending, (state) => {
        state.error = null;
      })
      .addCase(trainingHistory.fulfilled, (state, action) => {
        state.history = action.payload;
      })
      .addCase(trainingHistory.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const {
  addHistoryTableId,
  addHistoryData,
  deleteHistoryData,
  addSummary,
  addPrograms,
} = trainingProgrammeSlice.actions;
export default trainingProgrammeSlice.reducer;
